import * as React from "react";
import * as ReactDOM from "react-dom";
import "./index.scss";
import registerServiceWorker from "./registerServiceWorker";
import { configureOrmWithEntities } from "./Config/ConfigureEntities";
import { Action } from "redux-actions";
import { Provider } from "react-redux";
import { HashRouter as Router } from "react-router-dom";
import { AuthHelper } from "./helpers/AuthHelper";
import {
  setUserTokenAction,
  webGetUserDetailsAction,
  setUserFromTokenAction,
  webGetUserPortalDetailsAction
} from "./Entities/User/User.Actions";
import { ssoRedirectUrl } from "./helpers/WebHelper";
import { webGetActivityThemesAction } from "./Entities/ActivityTheme/ActivityTheme.Actions";
import AppSession from "./AppSession";

export const store = configureOrmWithEntities();
export type AppAction<Payload> = Action<Payload>;
export const keepLocal = process.env.REACT_APP_KEEP_LOCAL === 'true'; // toggle connection to webAPI
const isAuth = AuthHelper.UserHasToken(); // User is authenticated TODO: check if token is valid!

if (keepLocal) {
  store.dispatch(webGetUserDetailsAction());
  store.dispatch(webGetUserPortalDetailsAction());
  store.dispatch(webGetActivityThemesAction());

  ReactDOM.render(
    <Provider store={store}>
      <Router hashType="slash">
        <AppSession />
      </Router>
    </Provider>,
    document.getElementById("root") as HTMLElement
  );
} else {
  if (isAuth) {
    store.dispatch(setUserTokenAction(AuthHelper.GetUserToken()));
    store.dispatch(setUserFromTokenAction(AuthHelper.GetUserIdFromToken()));
    store.dispatch(webGetUserDetailsAction());
    store.dispatch(webGetUserPortalDetailsAction());
    store.dispatch(webGetActivityThemesAction());
    // Change to getCatalogueCourses
    ReactDOM.render(
      <Provider store={store}>
        <Router>
          <AppSession />
        </Router>
      </Provider>,
      document.getElementById("root") as HTMLElement
    );
  } else {
    // we redirect to SSO if we cant find the tokebn for the user.
    const returnUrl = window.location.href;
    const decodedUrl = encodeURIComponent(returnUrl);
    window.location.replace(ssoRedirectUrl + "&returnurl=" + decodedUrl);
  }
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx